//  Picks certain attributes from an object
//  eg: pick(state, ['userProfile', 'userProfileKits', 'userNameNotFound'])
//  Will return the attributes in the array from the state object
const pick = (obj, arr, ...rest) => {
	const newObj = {}
	const hasOwn = Object.prototype.hasOwnProperty
	arr.forEach((value) => {
		if (hasOwn.call(obj, value)) {
			newObj[value] = obj[value]
		}
	})
	return Object.assign(newObj, ...rest)
}

export default pick



// WEBPACK FOOTER //
// ./src/utilities/pick.js